import { PlatformLocation } from "@angular/common";
import { Component } from "@angular/core";
import { Event, NavigationEnd, NavigationStart, Router } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import { SeoService } from "./core/service/seo.service";
@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent {
  currentUrl: string;
  constructor(
    public _router: Router,
    location: PlatformLocation,
    private spinner: NgxSpinnerService,
    private seoService: SeoService
  ) {
    this._router.events.subscribe((routerEvent: Event) => {
      if (routerEvent instanceof NavigationStart) {
        this.spinner.show();
        this.currentUrl = routerEvent.url.substring(
          routerEvent.url.lastIndexOf("/") + 1
        );
      }
      if (routerEvent instanceof NavigationEnd) {
        this.spinner.hide();
        const seoData = this.seoService.getSeoDataForRoute(routerEvent.url);
        this.seoService.updateSeoMeta(seoData);
      }
      window.scrollTo(0, 0);
    });
  }

  ctrlShiftKey(e, keyCode) {
    return e.ctrlKey && e.shiftKey && e.keyCode === keyCode.charCodeAt(0);
  }
  
  onActivate(_event: any) {
    window.scroll(0, 0);
  }
}
